import { useEffect, useState } from 'react'
import type { PromptTemplate } from '../types'
import { listPrompts, updatePrompt, activatePrompt, createPrompt, deletePrompt } from '../services/promptApi'

export function PromptTemplates() {
  const [prompts, setPrompts] = useState<PromptTemplate[]>([])
  const [selected, setSelected] = useState<PromptTemplate | null>(null)
  const [status, setStatus] = useState('')

  const reload = async () => {
    const list = await listPrompts()
    setPrompts(list)
    setSelected((cur) => list.find((p) => p.id === cur?.id) ?? list.find((p) => p.is_active) ?? list[0] ?? null)
  }
  useEffect(() => { reload() }, [])

  const onSave = async () => {
    if (!selected) return
    try {
      await updatePrompt(selected.id, {
        display_name: selected.display_name, description: selected.description,
        prompt_text: selected.prompt_text, temperature: selected.temperature,
        max_tokens: selected.max_tokens, sort_order: selected.sort_order,
      })
      setStatus('Gespeichert.'); await reload()
    } catch (e: any) { setStatus('Fehler: ' + (e?.response?.data?.detail ?? e.message)) }
  }
  const onActivate = async () => { if (selected) { await activatePrompt(selected.id); setStatus('Aktiviert.'); await reload() } }
  const onNew = async () => {
    const name = prompt('model_name (eindeutig):'); if (!name) return
    const p = await createPrompt({ model_name: name, display_name: name, description: null,
      prompt_text: '', is_active: false, sort_order: null, api_model: null, temperature: null, max_tokens: null })
    await reload(); setSelected(p)
  }
  const onDelete = async () => { if (selected && confirm('Löschen?')) { await deletePrompt(selected.id); setStatus('Gelöscht.'); await reload() } }

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-gut8-anthracite mb-4">KI-Prompt-Vorlagen</h1>
      <div className="grid grid-cols-4 gap-4">
        <div className="col-span-1 bg-white border border-border-gut8-light rounded-gut8 shadow-gut8-sm p-2 space-y-1">
          <button className="text-sm font-medium text-primary hover:text-primary-hover mb-2" onClick={onNew}>+ Neues Template</button>
          {prompts.map((p) => (
            <button key={p.id} onClick={() => setSelected(p)}
                    className={`block w-full text-left px-3 py-2 rounded-gut8 text-sm text-gut8-anthracite hover:bg-gut8-bg-muted ${selected?.id === p.id ? 'bg-primary-subtle' : ''}`}>
              {p.display_name || p.model_name}{p.is_active && <span className="text-xs text-primary font-medium"> ● aktiv</span>}
            </button>
          ))}
        </div>

        <div className="col-span-3 space-y-3">
          {selected ? (
            <>
              <div className="flex gap-2 items-center">
                <input className="px-3 py-2 text-sm border border-border-gut8-medium rounded-gut8 bg-white focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary flex-1"
                       value={selected.display_name ?? ''} placeholder="Anzeigename"
                       onChange={(e) => setSelected({ ...selected, display_name: e.target.value })} />
                <button className="inline-flex items-center gap-2 px-4 h-9 rounded-gut8 border border-border-gut8-medium bg-white text-gut8-anthracite text-sm hover:bg-gut8-bg-muted disabled:opacity-40" onClick={onActivate} disabled={selected.is_active}>Aktivieren</button>
                <button className="inline-flex items-center gap-2 px-4 h-9 rounded-gut8 border border-border-gut8-medium bg-white text-secondary text-sm hover:bg-gut8-bg-muted" onClick={onDelete}>Löschen</button>
                <button className="inline-flex items-center gap-2 px-4 h-9 rounded-gut8 bg-primary text-text-inverse font-semibold text-sm hover:bg-primary-hover disabled:opacity-40" onClick={onSave}>Speichern</button>
              </div>
              {status && <div className="text-sm text-text-muted">{status}</div>}
              <textarea className="w-full h-[70vh] font-mono text-sm p-3 leading-relaxed border border-border-gut8-medium rounded-gut8 bg-white focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary"
                        value={selected.prompt_text} onChange={(e) => setSelected({ ...selected, prompt_text: e.target.value })} />
              <div className="text-xs text-text-muted">Der ==LAGEDATEN==-Block wird automatisch aus der Tabelle angehängt (nicht hier editierbar).</div>
            </>
          ) : <div className="text-text-muted">Kein Template gewählt.</div>}
        </div>
      </div>
    </div>
  )
}
